import React, { useEffect, useState } from 'react';
import useRouter from '../hook/useRouter';

export interface IOnOffProp {
    l10n: { [key: string]: string };
    watch: string;
    title: string;
    description: string;
    initVal: string;
    resetObj: { [key: string]: string };
    ga360str: string;
    submitCallback: (_d: string) => void;
}

export const OnOff = ({ props }: { props: IOnOffProp }) => {
    const { watch, title, l10n, description, initVal, submitCallback, resetObj, ga360str } = props;
    const { params, getValue, changeParam } = useRouter([watch]);
    const [dat, datSet] = useState(initVal);

    useEffect(() => {
        if (!params) return;
        const value = getValue(watch);
        if (!value) return;
        datSet(value);
    }, [params]);

    const [isButtonDisabled, setButtonDisabled] = useState<boolean>(false);

    const onChangeVal = (_bool: string) => {
        if (!isButtonDisabled) {
            setButtonDisabled(true);
            setTimeout(() => setButtonDisabled(false), 1000);
            changeParam({ [watch]: _bool, ...resetObj });
            submitCallback(_bool);
        }
    };

    return (
        <section className="sell">
            <header>{title}</header>
            <article>
                <p dangerouslySetInnerHTML={{ __html: description }}></p>
                <div>
                    <input
                        onChange={() => {
                            onChangeVal('true');
                        }}
                        checked={dat === 'true'}
                        disabled={isButtonDisabled}
                        type="radio"
                        id="on"
                        name="onoff"
                        value="true"
                    />
                    <label htmlFor="on" data-areas={ga360str} data-contents="ON">
                        ON
                    </label>
                    <br />
                    <input
                        onChange={() => {
                            onChangeVal('false');
                        }}
                        checked={dat === 'false'}
                        disabled={isButtonDisabled}
                        type="radio"
                        id="off"
                        name="onoff"
                        value="false"
                    />
                    <label htmlFor="off" data-areas={ga360str} data-contents="OFF">
                        OFF
                    </label>
                    <br />
                </div>
            </article>
        </section>
    );
};
